
import { defineComponent, SetupContext } from "vue";
export default defineComponent({
  name: "BannerItem",
  props: {
    /**
     * 表示
     */
    active: {
      type: Boolean,
      required: true
    }
  },
  setup(props, context: SetupContext) {

    const isActive = () => {
      return props.active;
    }

    return {
      isActive
    };
  }
});
